import { ChapterEditLanguageSection } from 'src/interfaces'

export const docSlotKey = (language: string) => `doc:${language}`

export const audioSlotKey = (bookAudioId: string) => `audio:${bookAudioId}`

export const applyRemovedSlotsToSections = (
	languageSections: ChapterEditLanguageSection[],
	removedSlots: Set<string>,
): ChapterEditLanguageSection[] =>
	languageSections
		.map((section) => {
			const docRemoved = removedSlots.has(docSlotKey(section.language))

			return {
				...section,
				docRemoved,
				docUrl: docRemoved ? null : section.docUrl,
				docProcessing: docRemoved ? false : section.docProcessing,
				audioVariants: section.audioVariants.filter(
					(variant) => !removedSlots.has(audioSlotKey(variant.bookAudioId)),
				),
			}
		})
		.filter(
			(section) =>
				section.audioVariants.length > 0 ||
				section.docUrl ||
				section.docProcessing ||
				(Boolean(section.docBookAudioId) &&
					!section.protectDocActions &&
					!section.docRemoved),
		)
